import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import App from './App';
import { initSupercellFonts } from './utils/get-is-supercell-template';

const container = document.getElementById('root');
const root = createRoot(container);

initSupercellFonts();

root.render(
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </BrowserRouter>
);
